import useReveal from '@/hooks/useReveal';

export default function HeroSection() {
  const { ref, visible } = useReveal();

  return (
    <section className="relative w-full min-h-screen flex items-start bg-background-50 overflow-hidden">
      <div
        ref={ref}
        className={`reveal ${visible ? 'visible' : ''} w-full flex flex-col lg:flex-row pt-28 md:pt-32 lg:pt-36 pb-20 px-6 md:px-10 lg:px-20`}
      >
        <div className="w-full lg:w-[35%] flex flex-col">
          <h1 className="font-heading text-[56px] sm:text-[64px] md:text-[80px] lg:text-[88px] leading-[0.92] tracking-[-0.03em] text-foreground-950">
            Gahnoo systems OU
          </h1>
          <p className="mt-24 md:mt-28 lg:mt-[100px] text-base sm:text-[17px] md:text-[18px] font-body font-normal leading-[1.5] text-foreground-800 max-w-[320px] sm:max-w-[360px] lg:max-w-[380px]">
            Professional engineering for the iOS platform — scalable, maintainable, and high-performance systems built with clean architecture and user-centered design.
          </p>
        </div>
        <div className="hidden lg:block lg:w-[65%]" />
      </div>
    </section>
  );
}